<template>
    <div id="report-contact-distributions">
        <div class="overall-content">
            <div class="chart-container">
                <div id="time-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon time-icon">
                            <md-icon>schedule</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.timeDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByTime
                            :title="$t('report.timeDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byTime"
                        />
                    </div>
                </div>

                <div id="channel-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon channel-icon">
                            <md-icon>device_hub</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.channelDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByChannel
                            :title="$t('report.channelDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byChannel"
                        />
                    </div>
                </div>

                <div id="tag-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon tag-icon">
                            <md-icon>label</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.tagDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByTag
                            :title="$t('report.tagDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byTag"
                        />
                    </div>
                </div>

                <div id="platform-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon platform-icon">
                            <md-icon>devices</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.platformDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByPlatform
                            :title="$t('report.platformDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byPlatform"
                        />
                    </div>
                </div>

                <div id="owner-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon owner-icon">
                            <md-icon>person</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.ownerDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByOwner
                            :title="$t('report.ownerDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byOwner"
                        />
                    </div>
                </div>

                <div id="language-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon language-icon">
                            <md-icon>translate</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.languageDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByLanguage
                            :title="$t('report.languageDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byLanguage"
                        />
                    </div>
                </div>

                <div id="ads-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon ads-icon">
                            <md-icon>campaign</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.adsDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByAd
                            :title="$t('report.adsDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byAd || []"
                        />
                    </div>
                </div>

                <div id="ad-name-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon adname-icon">
                            <md-icon>ads_click</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.adNameDistribution') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByAd
                            :title="$t('report.adNameDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byAdName || []"
                        />
                    </div>
                </div>

                <div id="adset-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon adset-icon">
                            <md-icon>view_carousel</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.adsetDistribution') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByAd
                            :title="$t('report.adsetDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byAdsetName || []"
                        />
                    </div>
                </div>

                <div id="campaign-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon campaign-icon">
                            <md-icon>flag</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.campaignDistribution') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByAd
                            :title="$t('report.campaignDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byCampaignName || []"
                        />
                    </div>
                </div>

                <div id="property-section" class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon property-icon">
                            <md-icon>tune</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.contactPropertyDistribution") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.contactDistributionsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ContactDistributionsByContactProperty
                            :title="$t('report.contactPropertyDistribution')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.byContactProperty"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Sağ taraf navigasyon -->
        <div class="section-navigator">
            <div
                v-for="(section, index) in sections"
                :key="section.id"
                class="nav-item"
                :class="{
                    active: activeSection === section.id,
                    [`section-color-${index + 1}`]: true,
                }"
                @click="scrollToSection(section.id)"
                :title="section.title"
            >
                <div class="invisible-hover-area"></div>
                <div class="nav-line"></div>
                <div class="nav-overlay">
                    <span class="nav-text">{{ section.title }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import ContactDistributionsByTime from "./ContactDistributionsByTime.vue";
import ContactDistributionsByChannel from "./ContactDistributionsByChannel.vue";
import ContactDistributionsByTag from "./ContactDistributionsByTag.vue";
import ContactDistributionsByPlatform from "./ContactDistributionsByPlatform.vue";
import ContactDistributionsByOwner from "./ContactDistributionsByOwner.vue";
import ContactDistributionsByLanguage from "./ContactDistributionsByLanguage.vue";
import ContactDistributionsByAd from "./ContactDistributionsByAd.vue";
import ContactDistributionsByContactProperty from "./ContactDistributionsByContactProperty.vue";

const log = log2("ContactDistributions");
export default {
    name: "ContactDistributions",
    components: {
        ContactDistributionsByTime,
        ContactDistributionsByChannel,
        ContactDistributionsByTag,
        ContactDistributionsByPlatform,
        ContactDistributionsByOwner,
        ContactDistributionsByLanguage,
        ContactDistributionsByAd,
        ContactDistributionsByContactProperty,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                byTime: { buckets: [], timeSeriesType: null },
                byChannel: [],
                byTag: [],
                byPlatform: [],
                byOwner: [],
                byLanguage: [],
                byAd: [],
                byAdName: [],
                byAdsetName: [],
                byCampaignName: [],
                byContactProperty: [],
            },
            activeSection: "time-section",
            sections: [
                { id: "time-section", title: this.$t("report.timeDistribution") },
                { id: "channel-section", title: this.$t("report.channelDistribution") },
                { id: "tag-section", title: this.$t("report.tagDistribution") },
                { id: "platform-section", title: this.$t("report.platformDistribution") },
                { id: "owner-section", title: this.$t("report.ownerDistribution") },
                { id: "language-section", title: this.$t("report.languageDistribution") },
                { id: "ads-section", title: this.$t("report.adsDistribution") },
                { id: "ad-name-section", title: this.$t("report.adNameDistribution") },
                { id: "adset-section", title: this.$t("report.adsetDistribution") },
                { id: "campaign-section", title: this.$t("report.campaignDistribution") },
                { id: "property-section", title: this.$t("report.contactPropertyDistribution") },
            ],
        };
    },
    methods: {
        async fetch() {
            log("fetchData", this.filters);
            try {
                const res = await REPORT_API.contactDistributionsAll(this.filters);
                log("contactDistributionsAll data fetched", res);
                this.data = {
                    ...this.data,
                    ...res,
                    byAd: res.byAd || [],
                    byAdName: res.byAdName || [],
                    byAdsetName: res.byAdsetName || [],
                    byCampaignName: res.byCampaignName || [],
                };
            } catch (error) {
                console.error("Error fetching contact distributions:", error);
            } finally {
                this.loading = false;
            }
        },
        scrollToSection(sectionId) {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        },
        handleScroll() {
            const sections = this.sections.map((s) => document.getElementById(s.id));
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            for (let i = sections.length - 1; i >= 0; i--) {
                const section = sections[i];
                if (section && section.offsetTop <= scrollPosition) {
                    this.activeSection = this.sections[i].id;
                    break;
                }
            }
        },
    },
    mounted() {
        this.fetch();
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
#report-contact-distributions {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;
    position: relative;

    .overall-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        background: var(--color-bg-neutral, #f5f5f5);
        width: 100%;
        min-height: 100vh;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .report-card {
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
                overflow: hidden;
                transition: box-shadow 0.2s ease;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
                }

                .report-card-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 20px 24px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                    .report-card-icon {
                        width: 44px;
                        height: 44px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        i {
                            font-size: 22px !important;
                            color: #fff;
                        }

                        &.time-icon { background: linear-gradient(135deg, #ff6b6b, #ee5a5a); }
                        &.channel-icon { background: linear-gradient(135deg, #4ecdc4, #45b7a0); }
                        &.tag-icon { background: linear-gradient(135deg, #45b7d1, #3a9fb8); }
                        &.platform-icon { background: linear-gradient(135deg, #96ceb4, #7ab89e); }
                        &.owner-icon { background: linear-gradient(135deg, #d4a5a5, #c09090); }
                        &.language-icon { background: linear-gradient(135deg, #9b5de5, #8a4ed0); }
                        &.ads-icon { background: linear-gradient(135deg, #f15bb5, #d94fa0); }
                        &.adname-icon { background: linear-gradient(135deg, #00bbf9, #00a3d9); }
                        &.adset-icon { background: linear-gradient(135deg, #f59e0b, #d97706); }
                        &.campaign-icon { background: linear-gradient(135deg, #10b981, #059669); }
                        &.property-icon { background: linear-gradient(135deg, #3b82f6, #2563eb); }
                    }

                    .report-card-title {
                        h2 {
                            font-size: 18px;
                            font-weight: 600;
                            margin: 0;
                            color: #1a1a1a;
                        }

                        .report-card-subtitle {
                            font-size: 13px;
                            color: #6b7280;
                            margin: 2px 0 0 0;
                        }
                    }
                }

                .report-card-body {
                    padding: 20px 24px;
                }
            }
        }
    }

    .section-navigator {
        position: fixed;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 100;
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 10px;

        .nav-item {
            position: relative;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 45px;
            transition: all 0.3s ease;

            .invisible-hover-area {
                position: absolute;
                right: 0;
                height: 100%;
                width: 250px;
                z-index: 1;
            }

            .nav-line {
                width: 6px;
                height: 100%;
                border-radius: 3px;
                transition: all 0.3s ease;
                position: relative;
                z-index: 2;
            }

            .nav-overlay {
                position: absolute;
                right: 0;
                height: 100%;
                width: 6px;
                opacity: 0;
                transition: all 0.3s ease;
                border-radius: 3px;
                display: flex;
                align-items: center;
                overflow: hidden;
                z-index: 1;

                .nav-text {
                    color: white;
                    white-space: nowrap;
                    padding: 0 20px;
                    opacity: 0;
                    transition: opacity 0.2s ease 0.1s;
                    font-weight: 500;
                    font-size: 14px;
                }
            }

            &:hover,
            &:hover .nav-overlay {
                .nav-line {
                    width: 8px;
                }

                .nav-overlay {
                    width: 220px;
                    opacity: 1;

                    .nav-text {
                        opacity: 1;
                    }
                }
            }

            &.active {
                .nav-line {
                    height: 55px;
                    width: 8px;
                }
            }

            &.section-color-1 { .nav-line { background: rgba(255, 107, 107, 0.8); } .nav-overlay { background: rgba(255, 107, 107, 0.95); } }
            &.section-color-2 { .nav-line { background: rgba(78, 205, 196, 0.8); } .nav-overlay { background: rgba(78, 205, 196, 0.95); } }
            &.section-color-3 { .nav-line { background: rgba(69, 183, 209, 0.8); } .nav-overlay { background: rgba(69, 183, 209, 0.95); } }
            &.section-color-4 { .nav-line { background: rgba(150, 206, 180, 0.8); } .nav-overlay { background: rgba(150, 206, 180, 0.95); } }
            &.section-color-5 { .nav-line { background: rgba(212, 165, 165, 0.8); } .nav-overlay { background: rgba(212, 165, 165, 0.95); } }
            &.section-color-6 { .nav-line { background: rgba(155, 93, 229, 0.8); } .nav-overlay { background: rgba(155, 93, 229, 0.95); } }
            &.section-color-7 { .nav-line { background: rgba(241, 91, 181, 0.8); } .nav-overlay { background: rgba(241, 91, 181, 0.95); } }
            &.section-color-8 { .nav-line { background: rgba(0, 187, 249, 0.8); } .nav-overlay { background: rgba(0, 187, 249, 0.95); } }
            &.section-color-9 { .nav-line { background: rgba(245, 158, 11, 0.8); } .nav-overlay { background: rgba(245, 158, 11, 0.95); } }
            &.section-color-10 { .nav-line { background: rgba(16, 185, 129, 0.8); } .nav-overlay { background: rgba(16, 185, 129, 0.95); } }
            &.section-color-11 { .nav-line { background: rgba(59, 130, 246, 0.8); } .nav-overlay { background: rgba(59, 130, 246, 0.95); } }
        }
    }
}
</style>
